import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 15000 });

export const api = {
  scenario:       () => client.get("/scenario").then(r => r.data),
  resetScenario:  () => client.post("/scenario/reset").then(r => r.data),
  evaluate:       (action_id, actor_role, note) =>
                    client.post("/katlas/evaluate", { action_id, actor_role, note }).then(r => r.data),
  approve:        (receipt_id, note) =>
                    client.post("/katlas/approve", { receipt_id, approver_role: "compliance", note }).then(r => r.data),
  sift:           () => client.get("/sift/predict").then(r => r.data),
  rwi:            (weights) => client.post("/rwi/run", weights).then(r => r.data),
  evidence:       () => client.get("/evidence").then(r => r.data),
  resetEvidence:  () => client.post("/evidence/reset").then(r => r.data),
  exportEvidence: () => client.get("/evidence/export").then(r => r.data),
  createSnapshot: (payload) => client.post("/snapshot", payload).then(r => r.data),
  getSnapshot:    (token) => client.get(`/snapshot/${token}`).then(r => r.data),

  // Live KATLAS-backed FreightCierge endpoints
  health:           () => client.get("/health").then(r => r.data),
  katlasStatus:     () => client.get("/katlas/status").then(r => r.data),
  katlasDiagnostics:(probe = "basic") => client.get(`/katlas/diagnostics?probe=${probe}`).then(r => r.data),
  freightScenario:  () => client.get("/freight/scenario").then(r => r.data),
  freightApprove:   (note) => client.post("/freight/exception-response/approve", { note }).then(r => r.data),
  freightRefuse:    (note) => client.post("/freight/exception-response/refuse", { note }).then(r => r.data),
  publicReceipt:    (hash) => client.get(`/r/${encodeURIComponent(hash)}`).then(r => r.data),
};
